(() => {
  const CARD_SELECTOR = 'product-card[data-product-id], .product-card[data-product-id]';
  const BOUND_ATTR = 'data-more-colours-bound';
  const PATH_ATTR = 'data-more-colours-path';
  const COLOR_RE = /\bcolou?r(?:s)?\b/i;
  const CACHE_PREFIX = 'more-colours-pill:v4:';
  const CACHE_TTL = 6 * 60 * 60 * 1000;
  const MAX_REQUESTS = 4;

  let activeRequests = 0;
  let pending = [];
  let inFlight = new Map();
  let memoryCache = new Map();
  let scanTimer = null;
  let activePopover = null;

  function injectStyles() {
    if (document.getElementById('more-colours-pill-style')) return;

    const style = document.createElement('style');
    style.id = 'more-colours-pill-style';
    style.textContent = `
      .more-colours-host {
        position: relative;
      }

      .more-colours-expand {
        position: relative;
        display: inline-flex;
        flex-direction: column;
        align-items: stretch;
        border-radius: 999px;
        background: rgba(255,255,255,.96);
        box-shadow: none;
        overflow: hidden;
        max-width: 130px;
        transition: max-height .24s ease, border-radius .2s ease, box-shadow .2s ease, transform .14s ease, background-color .14s ease;
        z-index: 8;
      }

      .more-colours-expand:hover {
        background: #fff;
        box-shadow: none;
        transform: translateY(-1px);
      }

      .more-colours-expand.is-open {
        border-radius: 16px;
        max-height: 120px;
        box-shadow: none;
        z-index: 20;
      }

      .more-colours-expand .more-colours-pill {
    appearance: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 6px 8px;
    border: 0;
    background: transparent;
    box-shadow: none;
    color: #333 !important;
    font-family: 'Manrope' !important;
    cursor: pointer;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0px !important;
    line-height: 1;
    text-transform: none;
    white-space: nowrap;
}

      .more-colours-expand .more-colours-pill:hover {
        background: transparent;
        box-shadow: none;
        transform: none;
      }

      .more-colours-expand .more-colours-pill:focus-visible {
        outline: 2px solid #111827;
        outline-offset: -2px;
      }

      .product-badges--top-left .more-colours-expand {
        margin: 10px;
    border-radius: 25px;
    color: #fff;
    background: #f6fc7f;
    border: 1px solid #111;
      }

      .more-colours-pill--overlay {
        position: absolute;
        top: 12px;
        left: 12px;
        z-index: 20;
      }

      .more-colours-panel {
      display: none;
        width: 100%;
        max-height: 0;
        opacity: 0;
        overflow: hidden;
        overflow-x: hidden;
        padding: 0 12px;
        box-sizing: border-box;
        transition: max-height .24s ease, opacity .18s ease, padding .18s ease;
      }

      .more-colours-expand.is-open .more-colours-panel {
        max-height: 110px;
        opacity: 1;
        padding: 0 12px 10px;
        overflow-y: auto;
        overflow-x: hidden;
      }

      .more-colours-swatch-list,
      .more-colours-text-list {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
        margin-top: 2px;
      }

      .more-colours-swatch {
        width: 10px;
        height: 10px;
        border-radius: 999px;
        border: 1px solid rgba(17,24,39,.12);
        box-shadow: inset 0 0 0 1px rgba(255,255,255,.5);
        flex: 0 0 auto;
      }

      .more-colours-text-item {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 3px 8px;
        border-radius: 999px;
        background: #f3f4f6;
        color: #111827;
        font-size: 11px;
        font-weight: 400;
        line-height: 1.2;
        white-space: nowrap;
      }

      @media (max-width: 749px) {
        .more-colours-expand {
          width: 118px;
          max-width: calc(100vw - 24px);
          max-height: 28px;
          overflow: hidden;
        }

        .more-colours-expand.is-open {
          max-height: 126px;
        }

        .more-colours-expand .more-colours-pill {
          font-size: 12px;
          padding: 4px 8px;
        }

        .product-badges--top-left .more-colours-expand {
          margin: 8px;
          width: 90px !important;
        }

        .more-colours-pill--overlay {
          top: 10px;
          left: 10px;
        }

        .more-colours-panel {
          width: 100%;
          overflow-x: hidden;
        }

        .more-colours-expand.is-open .more-colours-panel {
          max-height: 88px;
          padding: 0 8px 8px;
          overflow-y: auto;
          overflow-x: hidden;
          -webkit-overflow-scrolling: touch;
        }

        .more-colours-text-list {
          width: 100%;
          display: flex;
          flex-direction: column;
          flex-wrap: nowrap;
          align-items: stretch;
          gap: 4px;
          margin-top: 2px;
        }

        .more-colours-text-item {
          width: 100%;
          max-width: 100%;
          box-sizing: border-box;
          justify-content: center;
          padding: 2px 6px;
          font-size: 9px;
          line-height: 1.1;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .more-colours-swatch-list {
          width: 100%;
          gap: 4px;
          align-content: flex-start;
        }

        .more-colours-swatch {
          width: 9px;
          height: 9px;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function tidy(value) {
    return String(value == null ? '' : value).replace(/\s+/g, ' ').trim();
  }

  function absoluteUrl(value) {
    const text = tidy(value);
    if (!text) return '';
    if (text.startsWith('//')) return `${window.location.protocol}${text}`;
    if (/^https?:\/\//i.test(text)) return text;
    if (text.startsWith('/')) return `${window.location.origin}${text}`;
    return text;
  }

  function buildProductUrl(path) {
    const url = new URL(path, window.location.origin);
    const current = new URL(window.location.href);

    ['preview_theme_id', '_fd', 'pb'].forEach((key) => {
      if (current.searchParams.has(key) && !url.searchParams.has(key)) {
        url.searchParams.set(key, current.searchParams.get(key));
      }
    });

    return url.toString();
  }

  function getProductPath(card) {
    if (!card) return '';

    const cached = card.getAttribute(PATH_ATTR);
    if (cached) return cached;

    const link = card.querySelector('a.product-card__link[href*="/products/"], a[href*="/products/"]');
    if (!link) return '';

    try {
      const url = new URL(link.getAttribute('href'), window.location.origin);
      if (!url.pathname.startsWith('/products/')) return '';
      card.setAttribute(PATH_ATTR, url.pathname);
      return url.pathname;
    } catch {
      return '';
    }
  }

  function emptyPayload() {
    return {
      hasMoreColours: false,
      label: 'Colours',
      displayType: 'text',
      values: []
    };
  }

  function makePayload(label, displayType, values) {
    const seen = new Set();

    const cleaned = (values || [])
      .map((item) => ({
        label: tidy(item.label),
        swatchBackground: tidy(item.swatchBackground),
        swatchImage: absoluteUrl(item.swatchImage)
      }))
      .filter((item) => item.label)
      .filter((item) => {
        const key = item.label.toLowerCase();
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });

    const hasRenderableSwatches = cleaned.some((item) => item.swatchBackground || item.swatchImage);

    return {
      hasMoreColours: cleaned.length > 1,
      label: tidy(label) || 'Colours',
      displayType: displayType === 'swatch' && hasRenderableSwatches ? 'swatch' : 'text',
      values: cleaned
    };
  }

  function readCache(path) {
    if (memoryCache.has(path)) return memoryCache.get(path);

    try {
      const raw = sessionStorage.getItem(CACHE_PREFIX + path);
      if (!raw) return null;

      const parsed = JSON.parse(raw);
      if (!parsed || parsed.expiresAt <= Date.now() || !parsed.value) {
        sessionStorage.removeItem(CACHE_PREFIX + path);
        return null;
      }

      memoryCache.set(path, parsed.value);
      return parsed.value;
    } catch {
      return null;
    }
  }

  function writeCache(path, payload) {
    memoryCache.set(path, payload);

    try {
      sessionStorage.setItem(
        CACHE_PREFIX + path,
        JSON.stringify({
          value: payload,
          expiresAt: Date.now() + CACHE_TTL
        })
      );
    } catch {}
  }

  function extractBalancedJson(source, fromIndex) {
    const start = source.indexOf('{', fromIndex);
    if (start === -1) return '';

    let depth = 0;
    let inString = false;
    let escaped = false;

    for (let i = start; i < source.length; i++) {
      const ch = source[i];

      if (inString) {
        if (escaped) {
          escaped = false;
          continue;
        }

        if (ch === '\\') {
          escaped = true;
          continue;
        }

        if (ch === '"') inString = false;
        continue;
      }

      if (ch === '"') {
        inString = true;
        continue;
      }

      if (ch === '{') depth++;
      if (ch === '}') {
        depth--;
        if (depth === 0) return source.slice(start, i + 1);
      }
    }

    return '';
  }

  function parseJsonObjectAfter(source, marker) {
    const markerIndex = source.indexOf(marker);
    if (markerIndex === -1) return null;

    const jsonText = extractBalancedJson(source, markerIndex + marker.length);
    if (!jsonText) return null;

    try {
      return JSON.parse(jsonText);
    } catch {
      return null;
    }
  }

  function getHeading(container) {
    const direct = Array.from(container.children || []).find((child) => {
      const tag = child.tagName ? child.tagName.toUpperCase() : '';
      return tag === 'LABEL' || tag === 'LEGEND';
    });

    if (direct) return tidy(direct.textContent);

    const nested = container.querySelector('label, legend');
    return tidy(nested ? nested.textContent : '');
  }

  function findInputLabel(container, input) {
    if (!container || !input) return null;

    if (input.parentElement && input.parentElement.tagName && input.parentElement.tagName.toUpperCase() === 'LABEL') {
      return input.parentElement;
    }

    const id = input.getAttribute('id');
    if (!id) return null;

    return Array.from(container.querySelectorAll('label')).find((label) => label.getAttribute('for') === id) || null;
  }

  function isCssColour(value) {
    const text = tidy(value);
    return /^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(text) || /^(rgba?|hsla?)\(/i.test(text);
  }

  function isBackgroundValue(value) {
    const text = tidy(value);
    return isCssColour(text) || text.startsWith('linear-gradient(') || text.startsWith('radial-gradient(');
  }

  function extractSwatchInfo(node) {
    if (!node) return {};

    const candidates = [node, ...(node.querySelectorAll ? Array.from(node.querySelectorAll('*')) : [])];

    for (const candidate of candidates) {
      if (!candidate || !candidate.getAttribute) continue;

      const dataImage = candidate.getAttribute('data-swatch-image') || candidate.getAttribute('data-image');
      if (dataImage) return { swatchImage: absoluteUrl(dataImage) };

      const dataColor = candidate.getAttribute('data-swatch-color') || candidate.getAttribute('data-color');
      if (isBackgroundValue(dataColor)) return { swatchBackground: tidy(dataColor) };

      const styleText = candidate.getAttribute('style') || '';
      const bgImageMatch = styleText.match(/background-image\s*:\s*url\((['"]?)(.*?)\1\)/i);
      if (bgImageMatch && bgImageMatch[2]) return { swatchImage: absoluteUrl(bgImageMatch[2]) };

      const bgMatch = styleText.match(/background(?:-color)?\s*:\s*([^;]+)/i);
      if (bgMatch && isBackgroundValue(bgMatch[1])) return { swatchBackground: tidy(bgMatch[1]) };

      if (candidate.tagName && candidate.tagName.toUpperCase() === 'IMG' && candidate.getAttribute('src')) {
        return { swatchImage: absoluteUrl(candidate.getAttribute('src')) };
      }

      if (candidate.style) {
        if (candidate.style.backgroundImage) {
          const urlMatch = candidate.style.backgroundImage.match(/url\((['"]?)(.*?)\1\)/i);
          if (urlMatch && urlMatch[2]) return { swatchImage: absoluteUrl(urlMatch[2]) };
        }

        if (candidate.style.background && isBackgroundValue(candidate.style.background)) {
          return { swatchBackground: candidate.style.background };
        }

        if (candidate.style.backgroundColor && isCssColour(candidate.style.backgroundColor)) {
          return { swatchBackground: candidate.style.backgroundColor };
        }
      }
    }

    return {};
  }

  function extractNativePayload(doc) {
    if (!doc) return null;

    const containers = doc.querySelectorAll('.variant-option, fieldset, .product-form__input, .variant-picker__form > div');

    for (const container of containers) {
      const heading = getHeading(container);
      if (!COLOR_RE.test(heading)) continue;

      const select = container.querySelector('select');
      if (select) {
        const values = Array.from(select.querySelectorAll('option'))
          .map((option) => ({ label: tidy(option.textContent || option.value) }))
          .filter((item) => item.label);

        const payload = makePayload(heading, 'text', values);
        if (payload.values.length) return payload;
      }

      const values = [];

      Array.from(container.querySelectorAll('input[type="radio"], input[type="checkbox"]')).forEach((input) => {
        const labelNode = findInputLabel(container, input);
        const swatch = extractSwatchInfo(labelNode || input);

        const label = tidy(
          (labelNode && labelNode.textContent) ||
          input.getAttribute('aria-label') ||
          input.getAttribute('value') ||
          input.dataset.value ||
          ''
        );

        if (!label) return;

        values.push({
          label,
          swatchBackground: swatch.swatchBackground || '',
          swatchImage: swatch.swatchImage || ''
        });
      });

      if (!values.length) {
        Array.from(container.querySelectorAll('button, [role="radio"], [data-option-value-id]')).forEach((node) => {
          const swatch = extractSwatchInfo(node);
          const label = tidy(
            node.getAttribute('aria-label') ||
            node.getAttribute('data-value') ||
            node.getAttribute('value') ||
            node.textContent
          );

          if (!label) return;

          values.push({
            label,
            swatchBackground: swatch.swatchBackground || '',
            swatchImage: swatch.swatchImage || ''
          });
        });
      }

      if (values.length) {
        const type = values.some((item) => item.swatchBackground || item.swatchImage) ? 'swatch' : 'text';
        const payload = makePayload(heading, type, values);
        if (payload.values.length) return payload;
      }
    }

    return null;
  }

  function compareValue(actual, expected, where) {
    const left = String(actual == null ? '' : actual).trim().toLowerCase();
    const right = String(expected == null ? '' : expected).trim().toLowerCase();

    switch (String(where || 'EQUALS').toUpperCase()) {
      case 'EQUALS':
      case 'IS':
        return left === right;
      case 'NOT_EQUALS':
      case 'DOES_NOT_EQUAL':
      case 'IS_NOT':
        return left !== right;
      case 'CONTAINS':
        return left.includes(right);
      case 'NOT_CONTAINS':
      case 'DOES_NOT_CONTAIN':
        return !left.includes(right);
      case 'STARTS_WITH':
        return left.startsWith(right);
      case 'ENDS_WITH':
        return right ? left.endsWith(right) : false;
      default:
        return left === right;
    }
  }

  function conditionMatchesProduct(condition, product) {
    const select = String(condition.select || '').toUpperCase();
    const expected = condition.value;
    let list = [];

    if (select === 'TAG' || select === 'TAGS') list = Array.isArray(product.tags) ? product.tags : [];
    else if (select === 'COLLECTION' || select === 'COLLECTIONS' || select === 'COLLECTION_ID') list = Array.isArray(product.collections) ? product.collections : [];
    else if (select === 'VENDOR') list = [product.vendor];
    else if (select === 'TYPE' || select === 'PRODUCT_TYPE') list = [product.type];
    else if (select === 'TITLE' || select === 'PRODUCT_TITLE' || select === 'PRODUCT') list = [product.title];
    else if (select === 'HANDLE') list = [product.handle];
    else if (select === 'ID' || select === 'PRODUCT_ID') list = [product.id];
    else return false;

    return list.some((entry) => compareValue(entry, expected, condition.where));
  }

  function ruleMatchesProduct(rule, product) {
    if (!rule || !product) return false;

    if (rule.all && rule.all.enable) return true;

    const manualIds = rule.manual && Array.isArray(rule.manual.ids) ? rule.manual.ids : [];
    if (rule.manual && rule.manual.enable && manualIds.some((id) => String(id) === String(product.id))) {
      return true;
    }

    if (!rule.automate || !rule.automate.enable) return false;

    const conditions = Array.isArray(rule.automate.conditions) ? rule.automate.conditions : [];
    if (!conditions.length) return false;

    const operator = String(rule.automate.operator || 'and').toLowerCase() === 'or' ? 'or' : 'and';
    const matches = conditions.map((condition) => conditionMatchesProduct(condition, product));

    return operator === 'or' ? matches.some(Boolean) : matches.every(Boolean);
  }

  function globoSwatchBackground(optionValue) {
    const color1 = tidy(optionValue && optionValue.color1);
    const color2 = tidy(optionValue && optionValue.color2);
    const colorType = tidy(optionValue && optionValue.color_type).toLowerCase();

    if (colorType.includes('two') && isCssColour(color1) && isCssColour(color2)) {
      return `linear-gradient(135deg, ${color1} 0%, ${color1} 50%, ${color2} 50%, ${color2} 100%)`;
    }

    if (isCssColour(color1)) return color1;
    return '';
  }

  function findGloboColourPayload(elements) {
    const queue = Array.isArray(elements) ? [...elements] : [];

    while (queue.length) {
      const element = queue.shift();
      if (!element || typeof element !== 'object') continue;

      if (Array.isArray(element.elements) && element.elements.length) {
        queue.unshift(...element.elements);
      }

      const labelText = [element.label, element.label_en, element.label_on_cart].filter(Boolean).join(' ');
      if (!COLOR_RE.test(labelText)) continue;

      const optionValues = Array.isArray(element.option_values) ? element.option_values : [];
      if (!optionValues.length) continue;

      const values = optionValues.map((value) => ({
        label: value && (value.value_en || value.value || value.name),
        swatchBackground: globoSwatchBackground(value),
        swatchImage: value && value.asset_name ? value.asset_name : ''
      }));

      const displayType = String(element.type || '').toLowerCase().includes('swatch') ? 'swatch' : 'text';
      const payload = makePayload(element.label || element.label_en || element.label_on_cart, displayType, values);
      if (payload.values.length) return payload;
    }

    return null;
  }

  function extractGloboPayload(html) {
    if (!html.includes('window.GPOConfigs.options[')) return null;

    const product = parseJsonObjectAfter(html, 'window.GPOConfigs.product = ');
    if (!product || !product.id) return null;

    const collectionsMatch = html.match(/window\.GPOConfigs\.product\.collections\s*=\s*(\[[^\]]*\])/);
    if (collectionsMatch && collectionsMatch[1]) {
      try {
        product.collections = JSON.parse(collectionsMatch[1]);
      } catch {}
    }

    const marker = 'window.GPOConfigs.options[';
    let cursor = 0;

    while ((cursor = html.indexOf(marker, cursor)) !== -1) {
      const objectStart = html.indexOf('{', cursor);
      if (objectStart === -1) break;

      const jsonText = extractBalancedJson(html, objectStart);
      if (!jsonText) break;

      cursor = objectStart + jsonText.length;

      try {
        const config = JSON.parse(jsonText);
        if (!ruleMatchesProduct(config && config.products && config.products.rule, product)) continue;

        const payload = findGloboColourPayload(config.elements);
        if (payload && payload.values.length) return payload;
      } catch {}
    }

    return null;
  }

  function extractPayload(html) {
    let doc = null;

    try {
      doc = new DOMParser().parseFromString(html, 'text/html');
    } catch {}

    const nativePayload = extractNativePayload(doc);
    if (nativePayload && nativePayload.hasMoreColours) return nativePayload;

    const globoPayload = extractGloboPayload(html);
    if (globoPayload && globoPayload.hasMoreColours) return globoPayload;

    return emptyPayload();
  }

  function closePopover() {
    if (!activePopover) return;

    activePopover.button.setAttribute('aria-expanded', 'false');
    activePopover.shell.classList.remove('is-open');
    activePopover.panel.setAttribute('aria-hidden', 'true');
    activePopover = null;
  }

  function buildPanel(payload) {
    const panel = document.createElement('div');
    panel.className = 'more-colours-panel';
    panel.setAttribute('aria-hidden', 'true');

    const list = document.createElement('div');
    list.className = payload.displayType === 'swatch' ? 'more-colours-swatch-list' : 'more-colours-text-list';

    payload.values.forEach((item) => {
      if (payload.displayType === 'swatch') {
        const swatch = document.createElement('span');
        swatch.className = 'more-colours-swatch';
        swatch.setAttribute('title', item.label);
        swatch.setAttribute('aria-label', item.label);

        if (item.swatchImage) {
          swatch.style.backgroundImage = `url("${item.swatchImage}")`;
          swatch.style.backgroundSize = 'cover';
          swatch.style.backgroundPosition = 'center';
        } else if (item.swatchBackground) {
          swatch.style.background = item.swatchBackground;
        }

        list.appendChild(swatch);
      } else {
        const textItem = document.createElement('span');
        textItem.className = 'more-colours-text-item';
        textItem.textContent = item.label;
        textItem.setAttribute('title', item.label);
        list.appendChild(textItem);
      }
    });

    panel.appendChild(list);
    return panel;
  }

  function togglePopover(card, button) {
    const shell = button.closest('.more-colours-expand');
    const panel = shell ? shell.querySelector('.more-colours-panel') : null;
    if (!shell || !panel) return;

    if (activePopover && activePopover.button === button) {
      closePopover();
      return;
    }

    closePopover();

    shell.classList.add('is-open');
    button.setAttribute('aria-expanded', 'true');
    panel.setAttribute('aria-hidden', 'false');

    activePopover = {
      card,
      button,
      shell,
      panel
    };
  }

  function createButton(card, payload) {
    const shell = document.createElement('div');
    shell.className = 'more-colours-expand';

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'more-colours-pill';
    button.textContent = 'More colours';
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-haspopup', 'dialog');

    const panel = buildPanel(payload);

    button.addEventListener('pointerdown', (event) => {
      event.stopPropagation();
    });

    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      togglePopover(card, button);
    });

    shell.appendChild(button);
    shell.appendChild(panel);

    return shell;
  }

  function isVisibleElement(element) {
    if (!element) return false;

    const style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
      return false;
    }

    return element.getClientRects().length > 0;
  }

  function renderBadge(card, payload) {
    if (!card || !payload || !payload.hasMoreColours) return;
    if (card.querySelector('.more-colours-expand')) return;

    const badge = createButton(card, payload);
    const badgeHost = card.querySelector('.product-badges--top-left');

    if (isVisibleElement(badgeHost)) {
      badgeHost.appendChild(badge);
      return;
    }

    const overlayHost =
      card.querySelector('.card-gallery') ||
      card.querySelector('.product-card__content') ||
      card;

    if (!overlayHost) return;

    overlayHost.classList.add('more-colours-host');
    badge.classList.add('more-colours-pill--overlay');
    overlayHost.appendChild(badge);
  }

  function processJob(job) {
    fetch(buildProductUrl(job.path), {
      credentials: 'same-origin',
      headers: {
        Accept: 'text/html,application/xhtml+xml'
      }
    })
      .then((response) => {
        if (!response.ok) throw new Error('Failed to fetch product page');
        return response.text();
      })
      .then((html) => {
        const payload = extractPayload(html);
        writeCache(job.path, payload);
        job.resolve(payload);
      })
      .catch(() => {
        job.resolve(emptyPayload());
      })
      .finally(() => {
        activeRequests--;
        inFlight.delete(job.path);
        pumpQueue();
      });
  }

  function pumpQueue() {
    while (activeRequests < MAX_REQUESTS && pending.length) {
      activeRequests++;
      processJob(pending.shift());
    }
  }

  function loadPayload(path) {
    if (!path) return Promise.resolve(emptyPayload());

    const cached = readCache(path);
    if (cached) return Promise.resolve(cached);

    if (inFlight.has(path)) return inFlight.get(path);

    const promise = new Promise((resolve) => {
      pending.push({ path, resolve });
      pumpQueue();
    });

    inFlight.set(path, promise);
    return promise;
  }

  function scanCards() {
    document.querySelectorAll(CARD_SELECTOR).forEach((card) => {
      if (card.getAttribute(BOUND_ATTR) === '1') return;

      const path = getProductPath(card);
      if (!path) return;

      card.setAttribute(BOUND_ATTR, '1');

      loadPayload(path).then((payload) => {
        if (payload && payload.hasMoreColours) {
          renderBadge(card, payload);
        }
      });
    });
  }

  function scheduleScan() {
    clearTimeout(scanTimer);
    scanTimer = setTimeout(scanCards, 80);
  }

  document.addEventListener('click', (event) => {
    if (!activePopover) return;
    if (activePopover.shell.contains(event.target)) return;
    closePopover();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closePopover();
  });

  window.addEventListener('resize', closePopover);
  document.addEventListener('scroll', closePopover, true);

  injectStyles();
  scanCards();

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes && mutation.addedNodes.length) {
        scheduleScan();
        return;
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
